export enum AdditionalFees {
  AC_TAX = "ac_tax",
  AMVIC = "amvic",
  BUILD_PRICE = "build_price",
  DEALER_FEE = "dealer_fee",
  FEDERAL_ELECTRIC_INCENTIVE = "federal_electric_incentive",
  FREIGHT_AND_PDI = "freight_and_pdi",
  OMVIC = "omvic",
  PPSA = "ppsa",
  PROVINCIAL_ELECTRIC_INCENTIVE = "provincial_electric_incentive",
  RDPRM = "rdprm",
  SALES_TAX= "sales_tax",
  TIRE_AC_TAX = "tire_ac_tax",
  TIRE_TAX = "tire_tax",
};
